var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mb-3"},[_vm._v("CitSci Terms of Use and Privacy Policy")]),_vm._v(" "),_c('Terms'),_vm._v(" "),_c('Privacy')],1)}
var staticRenderFns = []
export { render, staticRenderFns }